var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-carefully",
    class: {
      'onlyShowSelected': !_vm.isEmpty && _vm.onlyShowSelected,
      'inPreviewEmpty': _vm.onlyShowSelected && _vm.inPreview && _vm.isEmpty
    }
  }, [_c('div', {
    staticClass: "carefully-list-title"
  }, [_c('span', [_vm._v("店铺精选")]), !_vm.inPreview ? _c('span', {
    staticClass: "title-tips"
  }, [_vm._v("你推广过的商品会自动进入店铺精选")]) : _vm._e()]), _vm._l(_vm.list, function (item, index) {
    return item.goodsId ? _c('div', {
      key: index,
      staticClass: "product-item J_Report",
      attrs: {
        "data-item_id": item.goodsId,
        "id": 'carefully_' + item.goodsId,
        "data-product_category": "product"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.toProductAddress(item);
        }
      }
    }, [_vm.inPreview ? _c('normalItem', {
      attrs: {
        "in-preview": _vm.inPreview,
        "item": item
      }
    }) : _c('editProductItem', {
      attrs: {
        "in-preview": _vm.inPreview,
        "index": index,
        "item": item,
        "length": _vm.list.length
      },
      on: {
        "remove": _vm.showDialog,
        "totop": _vm.toTop
      }
    })], 1) : _vm._e();
  }), _c('empty', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.inPreview && _vm.isEmpty,
      expression: "!inPreview&&isEmpty"
    }]
  }), _c('inPreviewEmpty', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.inPreview && _vm.isEmpty,
      expression: "inPreview&&isEmpty"
    }],
    attrs: {
      "onlyShowSelected": _vm.onlyShowSelected
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.inPreview && !_vm.isEmpty,
      expression: "!inPreview&&!isEmpty"
    }],
    staticClass: "bottom-tips"
  }, [_vm._v("每个城市最多添加30个商品，失效商品自动下架")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.inPreview && !_vm.isEmpty && _vm.list.length < 30,
      expression: "!inPreview&&!isEmpty&&list.length<30"
    }],
    staticClass: "more-btn",
    on: {
      "click": _vm.addGoods
    }
  }, [_vm._v("继续添加")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dialog.show,
      expression: "dialog.show"
    }],
    staticClass: "remove-dialog"
  }, [_c('div', {
    staticClass: "overlay",
    class: {
      show: _vm.dialog.showContent
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.closeDialog.apply(null, arguments);
      }
    }
  }), _c('div', {
    staticClass: "dialog-body",
    class: {
      show: _vm.dialog.showContent
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v("确认下架商品？")]), _c('div', {
    staticClass: "button-box"
  }, [_c('div', {
    staticClass: "cancel-btn",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.closeDialog.apply(null, arguments);
      }
    }
  }, [_vm._v("取消")]), _c('div', {
    staticClass: "confirm-btn",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.remove.apply(null, arguments);
      }
    }
  }, [_vm._v("确认下架")])])])])])], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };